// Page de consentement OAuth (Ordre 30) — petites règles pures, testées dans oauthConsent.test.js.

// Où renvoyer la personne après connexion : une adresse INTERNE seulement (jamais un autre site, jamais `//hôte`, jamais un antislash).
export function safeNext(value) {
  if (typeof value !== "string" || value.length > 600) return null;
  if (!value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u001f]/.test(value)) return null;
  return value;
}

// Une adresse de retour OAuth renvoyée par le serveur : https, ou http sur la machine locale (Claude Code, Codex). Sinon on ne s'y rend pas.
export function safeRedirect(value) {
  try {
    const url = new URL(value);
    const local = ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname);
    if (url.protocol === "https:" || (url.protocol === "http:" && local)) return url.toString();
  } catch (e) {
    // adresse illisible : refusée plus bas
  }
  return null;
}

// Domaines cochés au départ : tous ceux que la personne peut partager, sauf les « expressément » (cartographie du système).
export function defaultDomains(domains) {
  return (domains || []).filter((d) => !d.explicit).map((d) => d.id);
}

// Tri stable pour l'affichage : par libellé français.
export function sortDomains(domains, labelOf) {
  return [...(domains || [])].sort((a, b) => labelOf(a.id).localeCompare(labelOf(b.id), "fr"));
}

export const DOMAIN_NOTES = {
  architecture: "Structure interne de Jamora CRM (routes, droits, collections). Pour les agents de code ; ne contient ni code ni secret.",
};

// Ce qui s'affiche selon la réponse du serveur à la lecture de la demande.
export function requestProblem(error) {
  const status = error?.response?.status;
  if (status === 403) return "forbidden";
  if (status === 404) return "gone";
  return "error";
}
